package com.milta.core.localization.translations.de

import com.milta.core.localization.UnlocatedDeliveryStrings

internal val UnlocatedDelivery = UnlocatedDeliveryStrings(
    warningTitleSingular = "1 Adresse nicht lokalisiert",
    warningTitlePlural = "%d Adressen nicht lokalisiert",
    warningMessage = "Diese Lieferungen konnten nicht auf der Karte platziert werden. Korrigieren Sie ihre Adresse oder fahren Sie fort: Sie werden ans Ende der Tour gesetzt.",
    fixAction = "Korrigieren",
    continueWithoutAction = "Ohne sie fortfahren",
    unplacedStopsSingular = "1 Stopp nicht platziert, am Ende der Tour",
    unplacedStopsPlural = "%d Stopps nicht platziert, am Ende der Tour",
    fixAddressAction = "Adresse korrigieren",
    unlocatedBadge = "Nicht lokalisiert",
)
